import { computed, ref } from 'vue';
import OfflineSubmissionService from '../services/OfflineSubmissionService';

export const pendingQueueCount = ref(0);

export const refreshPendingQueueCount = async () => {
  pendingQueueCount.value = await OfflineSubmissionService.getPendingCount();
  return pendingQueueCount.value;
};

export function useOfflineQueue() {
  return {
    pendingQueueCount: computed(() => pendingQueueCount.value),
    refreshPendingQueueCount,
  };
}
